[
  {
    "id": "free",
    "name": "Free",
    "subscriber_count": 100,
    "url": "",
    "price": 0,
    "metered": false,
    "metered_price_per_thousand": 0,
    "features": [
      "analytics",
      "api",
      "archives",
      "custom_sending_domain",
      "firewall",
      "markdown",
      "scheduling",
      "smtp_endpoint"
    ]
  },
  {
    "id": "buttondown",
    "name": "Buttondown",
    "subscriber_count": 999999,
    "url": "",
    "price": 0,
    "metered": true,
    "metered_price_per_thousand": 9,
    "features": [
      "analytics",
      "api",
      "archives",
      "attachments",
      "automations",
      "comments",
      "concierge_migration",
      "css",
      "custom_domain",
      "custom_sending_domain",
      "custom_transactional_emails",
      "customer_service",
      "dedicated_ip",
      "firewall",
      "integrations",
      "markdown",
      "metadata",
      "multiple_newsletters",
      "paid_subscriptions",
      "rss_automation",
      "scheduling",
      "smtp_endpoint",
      "sponsorships",
      "subscriber_cleanup",
      "forms","surveys",
      "tags",
      "teams",
      "webhooks",
      "zapier"
    ]
  },
  {
    "id": "buttondown_plus",
    "name": "Buttondown Plus",
    "subscriber_count": 999999,
    "url": "",
    "price": 0,
    "metered": true,
    "metered_price_per_thousand": 14,
    "features": [
      "analytics",
      "api",
      "archives",
      "attachments",
      "automations",
      "comments",
      "concierge_migration",
      "css",
      "custom_domain",
      "custom_sending_domain",
      "custom_transactional_emails",
      "customer_service",
      "dedicated_ip",
      "firewall",
      "integrations",
      "markdown",
      "metadata",
      "multiple_newsletters",
      "naked_mode",
      "paid_subscriptions",
      "rss_automation",
      "scheduling",
      "smtp_endpoint",
      "sponsorships",
      "subscriber_cleanup",
      "forms","surveys",
      "tags",
      "teams",
      "webhooks",
      "whitelabeling",
      "zapier"
    ]
  }
]
